import React, { useState } from 'react';
import ManageAttribute from '../ManageAttribute/ManageAttribute';
import TreeComponent from '../../Tree/TreeComponent';
import { Form } from 'antd';
import SelectCommon from '../../Select/SelectCommon';
import { InputCommon } from '../../Input/InputCommon';
import { ButtonCommon } from '../../Button/ButtonCommon';
import { PlusOutlined } from '@ant-design/icons';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Attribute, AttributeManagerProps } from 'types';

const AttributeManager: React.FC<AttributeManagerProps> = ({
  treeList,
  attributes,
  isEdits = true,
  type = 'attribute',
  onTreeListChange,
  placeholderTitle = 'Chọn danh mục',
  placeholderSurcharge = 'Nhập vào giá tính thêm',
  placeholderNote = 'Nhập ghi chú',
  buttonName = 'Thêm thuộc tính',
}) => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const [form] = Form.useForm();
  const handleAddTreeNode = (values: Attribute) => {
    const newOrder = treeList.length > 0 ? treeList[treeList.length - 1].order + 1 : 1;
    const selectedLabel = attributes?.find((attr) => attr.value === values.title)?.name || '';
    const newAttribute = {
      attributeId: values.title,
      title: selectedLabel,
      salePrice: isNaN(Number(values.surcharge)) ? 0 : Number(values.surcharge),
      surcharge: isNaN(Number(values.surcharge)) ? 0 : Number(values.surcharge),
      costPrice: 0,
      note: values.note || '',
      order: newOrder,
    } as Attribute;
    onTreeListChange([...treeList, newAttribute] as Attribute[]);
    setIsFormVisible(false);
    form.resetFields();
  };
  return (
    <div>
      <TreeComponent variantStatus={isEdits ? 'default' : 'disable'}>
        {[...(treeList ?? [])]
          .sort((a, b) => a.order - b.order)
          .map((treeNode) => (
            <ManageAttribute
              isEdits={isEdits}
              key={treeNode.order}
              attributes={attributes}
              title={treeNode.title || ''}
              surcharge={treeNode.salePrice || 0}
              note={treeNode.note}
              type={type}
              onSaveChange={(updatedData) => {
                const newList = treeList.map((item) => {
                  if (item.order === updatedData.order) {
                    const selectedLabel = attributes?.find((attr) => attr.value === updatedData.title)?.name || '';
                    return {
                      attributeId: updatedData.title,
                      title: selectedLabel,
                      salePrice: updatedData.surcharge,
                      costPrice: 0,
                      order: updatedData.order,
                      note: updatedData.note,
                    };
                  }

                  return item;
                });
                if ((treeList as Attribute[])[0]?.attributeId !== undefined) {
                  onTreeListChange(newList as Attribute[]);
                }
              }}
              onDeleteTree={(order) => {
                if ((treeList as Attribute[])[0]?.attributeId !== undefined) {
                  const newList = (treeList as Attribute[]).filter((item) => item.order !== order);
                  onTreeListChange(newList);
                }
              }}
              order={treeNode.order}
            />
          ))}
      </TreeComponent>
      {isFormVisible && (
        <div className='flex-center h-16 bg-[var(--bgBlackOpacity5)] rounded-2xl mt-3'>
          <Form form={form} layout='vertical' onFinish={handleAddTreeNode} className='flex-center   w-full'>
            <Form.Item name='title' className='mb-0 px-2 min-w-[230px]'>
              <SelectCommon
                placeholderSelect={placeholderTitle}
                className='bg-white'
                options={attributes?.map((attribute) => ({
                  label: attribute?.name,
                  value: attribute?.value,
                }))}
                selectType='filterSelect'
              />
            </Form.Item>
            <Form.Item name='surcharge' className='mb-0 px-2 max-w-[230px] w-full'>
              <InputCommon
                type='money'
                placeholder={placeholderSurcharge}
                className='!px-3 bg-white'
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    form.submit();
                  }
                }}
              />
            </Form.Item>
            <Form.Item name='note' className='mb-0 px-2 max-w-[994px] w-full'>
              <InputCommon
                type='text'
                placeholder={placeholderNote}
                className='!px-3 bg-white'
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    form.submit();
                  }
                }}
              />
            </Form.Item>
          </Form>
          <div className='flex-center justify-center gap-2 min-w-20'>
            <DoneRoundedIcon
              onClick={() => form.submit()}
              sx={{ fontSize: 20, color: 'var(--sematicSuccessColor500)', cursor: 'pointer' }}
            />
            <CloseRoundedIcon
              onClick={() => {
                setIsFormVisible(false);
                form.resetFields();
              }}
              sx={{ fontSize: 20, color: 'var(--sematicErrorColor500)', cursor: 'pointer' }}
            />
          </div>
        </div>
      )}
      {isEdits && (
        <div className='flex justify-start mt-3'>
          <ButtonCommon
            color='basic'
            fullWidth
            radius='rounded'
            size='md'
            className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2 max-w-[176px]'
            onClick={() => setIsFormVisible(true)}
          >
            <PlusOutlined style={{ fontSize: '16px' }} />
            <span className='whitespace-nowrap'>{buttonName}</span>
          </ButtonCommon>
        </div>
      )}
    </div>
  );
};

export default AttributeManager;
